import styled from '@emotion/styled';
import { Button, Snackbar, useMediaQuery } from '@material-ui/core';
import { SnackbarOrigin } from '@material-ui/core/Snackbar';
import { SnackbarContentProps } from '@material-ui/core/SnackbarContent';
import { TransitionProps } from '@material-ui/core/transitions/transition';
import { ClassAttributes, ComponentType, createElement, SyntheticEvent } from 'react';
import { FormattedMessage } from 'react-intl';

import theme from '../../../theme';

type Props = ClassAttributes<HTMLElement> & {
  anchorOrigin?: SnackbarOrigin;
  autoHideDuration?: number;
  message: string | null;
  messageValues?: Record<string, any>;
  action?: string;
  actionValues?: Record<string, any>;
  buttonColor?: 'default' | 'inherit' | 'primary' | 'secondary';
  raw?: boolean;
  onClickAction?: (e: SyntheticEvent<HTMLElement>) => void;
  onRequestClear: (e: SyntheticEvent<HTMLElement>) => void;
  className?: string;
  transition?: ComponentType<TransitionProps>;
  ContentProps?: Partial<SnackbarContentProps>;
  error?: boolean;
  warning?: boolean;
  info?: boolean;
};

const FormattedSnackbar = ({
  anchorOrigin,
  autoHideDuration,
  message,
  messageValues,
  action,
  actionValues,
  buttonColor = 'secondary',
  raw,
  onClickAction,
  onRequestClear,
  className,
  transition,
  ContentProps,
  error,
  warning,
  info,
}: Props) => {
  const isSmartPhone = useMediaQuery(theme.breakpoints.down('xs'));
  return (
    <Snackbar_
      anchorOrigin={anchorOrigin}
      autoHideDuration={autoHideDuration}
      open={!!message}
      message={
        message ? raw ? <span>{message}</span> : <FormattedMessage id={message} values={messageValues} /> : undefined
      }
      action={
        action ? (
          <Button color={buttonColor} size="small" onClick={onClickAction}>
            {/* TODO: 一旦false固定 */}
            {/* eslint-disable-next-line no-constant-condition */}
            {false ? <Message>{action}</Message> : <FormattedMessage id={action} values={actionValues} />}
          </Button>
        ) : (
          undefined
        )
      }
      onClose={onRequestClear}
      className={className}
      TransitionComponent={transition}
      ContentProps={ContentProps}
      style={isSmartPhone ? { width: '70%' } : undefined}
      warning={warning}
      error={error}
      info={info}
    />
  );
};

const Message = styled('span')({ wordBreak: 'break-all', color: 'inherit' });

const Snackbar_ = styled(Snackbar)<{ error?: boolean; warning?: boolean; info?: boolean }>`
  .MuiSnackbarContent-root {
    background-color: ${({ warning, error, info }) => {
      return error
        ? '#FE7877!important;'
        : warning
        ? '#FCB100!important;'
        : info
        ? '#5FA9FF!important;'
        : `#2DCC70!important;`;
    }};
  }
`;

export default FormattedSnackbar;
